import axios from "axios";
import React, { useContext, useState } from "react";
import { LoginUserContext } from "../provider/LoginUserProvider";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const useLogin = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const { setLoginUser, setIsLogined, setToken } = useContext(LoginUserContext);
  const navigate = useNavigate();
  const login = (user) => {
    // const endpoint = `${API_URL}/auth/`;
    const endpoint = `/auth/`;
    const queries = { username: user.username, password: user.password };
    axios
      .post(endpoint, queries)
      .then((res) => {
        if (Object.keys(res.data).length > 0) {
          Cookies.set("token", res.data.token, {
            expires: 7,
          });
          setToken(res.data.token);
          setLoginUser(user.username);
          setIsLogined(true);

          navigate("/", { state: { name: user.username } });
        } else {
          navigate("/loginfailed");
        }
      })
      .catch((e) => {
        setLoginUser("");
        navigate("/loginfailed");
      });
  };
  return { login };
};

export default useLogin;
